import { boot } from "quasar/wrappers";
import AppButtonBack from "src/components/utils/app-button-back.vue";
import AppSelect from "src/components/utils/app-select.vue";
import ClipboardButton from "src/components/utils/clipboard-button.vue";
import DateRange from "src/components/utils/date-range.vue";
import InnerLoading from "src/components/utils/inner-loading/inner-loading.vue";
// DnD
import DragItem from "src/components/utils/dnd/drag-item.vue";
import DropArea from "src/components/utils/dnd/drop-area.vue";
// Btns
import BtnDefault from "src/components/utils/btn/btn-default.vue";
import BtnCheckbox from "src/components/utils/btn/btn-checkbox.vue";
import BtnClipboard from "src/components/utils/btn/btn-clipboard.vue";
import BtnDropdown from "src/components/utils/btn/btn-dropdown.vue";
import BtnFullscreen from "src/components/utils/btn/btn-fullscreen.vue";
import BtnModal from "src/components/utils/btn/btn-modal.vue";
import BtnToggle from "src/components/utils/btn/btn-toggle.vue";

export default boot(({ app }) => {
  app.component("app-button-back", AppButtonBack);
  app.component("app-select", AppSelect);
  app.component("clipboard-button", ClipboardButton);
  app.component("date-range", DateRange);
  app.component("InnerLoading", InnerLoading);
  // DnD
  app.component("DragItem", DragItem);
  app.component("DropArea", DropArea);
  // Btns
  app.component("BtnDefault", BtnDefault);
  app.component("BtnCheckbox", BtnCheckbox);
  app.component("BtnClipboard", BtnClipboard);
  app.component("BtnDropdown", BtnDropdown);
  app.component("BtnFullscreen", BtnFullscreen);
  app.component("BtnModal", BtnModal);
  app.component("BtnToggle", BtnToggle);
});
